module.exports = __webpack_public_path__ + "img/lightbulb-solid updated.17689516.svg";